// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_4-TabsClearable_tabs_32Rdo","icon":"_4-TabsClearable_icon_1hrNE"};